import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Stack } from "@mui/material";
import EGDatePicker from "../../../../MainComponents/DatePicker/EGDatePicker";
import { EGBasicSelect } from "../../../../MainComponents/Select/EGBasicSelect";
import { ClosedFounded } from "./ClosedFounded";
import { ClosedUnfounded } from "./ClosedUnfounded";
import { ClosedUndetermined } from "./ClosedUndetermined";
import { ClosedInadmissible } from "./ClosedInadmissible";
import { EGButton } from "../../../../MainComponents/Button/EGButton/EGButton";
import { ResolutionSummary } from "./ResolutionSummary";
import "./CloseReport.scss";

export const SubmitButtons = ({
  disabledSave,
  hideCancel = true,
  onSave = () => {},
  isLoading,
  onCancel = () => {},
}) => {
  const [t] = useTranslation("report");
  return (
    <Stack
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      flexDirection="row"
      spacing={2}
    >
      <EGButton
        label={t("Conclusion.save")}
        iconName={"mark_check_bold"}
        disabled={disabledSave}
        onClick={onSave}
        color={disabledSave ? "light" : "success"}
        iconColor={disabledSave ? "" : "white"}
        iconColorHover={disabledSave ? "" : "white"}
        labelColor={disabledSave ? "" : "white"}
        loading={isLoading}
      />
      {!hideCancel && (
        <EGButton
          label={t("Conclusion.cancel")}
          iconName="close_icon"
          iconSize={21}
          onClick={onCancel}
          loading={isLoading}
        />
      )}
    </Stack>
  );
};

// Report conclusion and closure details
export const CloseReport = ({
  reportDetail,
  reportRender,
  editClosed,
  setEditClosed,
  setShowInput,
}) => {
  const { id } = useParams();
  const [t] = useTranslation("report");

  const [closeDate, setCloseDate] = useState(
    reportDetail?.status?.details?.close_date || dayjs()
  );
  const [closeType, setCloseType] = useState(
    reportDetail?.status?.details?.closed || ""
  );
  const [reportExpired, setReportExpired] = useState(false);

  // Check if report is currently expired
  useEffect(() => {
    if (reportDetail?.created_at && reportDetail?.expired_report) {
      // Convertir created_at en un objeto Date
      const createdAt = new Date(reportDetail.created_at);

      // Obtener la fecha actual
      const currentDate = new Date();

      // Calcular la diferencia en milisegundos y luego convertir a días
      const differenceInTime = currentDate - createdAt;
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);

      // Verificar si la diferencia es mayor que expired_report
      const isExpired = differenceInDays > reportDetail.expired_report;
      setReportExpired(isExpired);
    }
  }, []);


  console.log("Tenant",  localStorage.getItem("Tenant") );

  let kindOfClosedOptions;

  if( localStorage.getItem("Tenant") == '"odoo_wwwlineaeticalive"' ){
    // Status report type
    kindOfClosedOptions = [
      {
        label: "Cerrada Veraz",
        value: "founded",
      },
      {
        label: "Cerrada no Veraz ",
        value: "unfounded",
      },
      // { 
      //   label: "Cerrada por falta de información/elementos", 
      //   value: "inadmissible" },
      {
        label: "Cerrada por otros motivos",
        value: "undefined",
      },
    ];

    
  } else {

    // Status report type
    kindOfClosedOptions = [
      {
        label: t("Conclusion.closed_founded"),
        value: "founded",
      },
      {
        label: t("Conclusion.closed_unfounded"),
        value: "unfounded",
      },
      //{ label: t("Conclusion.inadmissible_report"), value: "inadmissible" },
      {
        label: t("Conclusion.closed_undetermined"),
        value: "undefined",
      },
    ];

  }

  return (
    <div className="porcess-closed mt-20">
      {/* Mostrar resumen de la resolución guardada */}
      <ResolutionSummary reportDetail={reportDetail} />

      <Stack
        direction={{ xs: "column", lg: "row" }}
        spacing={2}
        marginBottom={2}
      >
        {localStorage.getItem("Tenant") !== '"odoo_wwwlineaeticalive"' && <EGDatePicker
          label={`${t("Conclusion.choose_Close_date")}:`}
          value={dayjs(closeDate)}
          onChange={(date) => setCloseDate(date)}
        />}

        <EGBasicSelect
          label={`${t("Conclusion.select_closed_type")}:`}
          value={closeType}
          onChange={(e) => setCloseType(e.target.value)}
          options={kindOfClosedOptions}
          required
          isValid={false}
          showSuccessValidation
          showHelpText={false}
        />
      </Stack>

      {closeType === "founded" && (
        <ClosedFounded
          id={id}
          reportDetail={reportDetail}
          reportExpired={reportExpired}
          closeDate={closeDate}
          reportRender={reportRender}
          editClosed={editClosed}
          setEditClosed={setEditClosed}
        />
      )}
      {closeType === "unfounded" && (
        <ClosedUnfounded
          id={id}
          reportDetail={reportDetail}
          reportExpired={reportExpired}
          closeDate={closeDate}
          reportRender={reportRender}
          editClosed={editClosed}
          setEditClosed={setEditClosed}
        />
      )}
      {closeType === "undefined" && (
        <ClosedUndetermined
          id={id}
          reportDetail={reportDetail}
          reportExpired={reportExpired}
          closeDate={closeDate}
          reportRender={reportRender}
          editClosed={editClosed}
          setEditClosed={setEditClosed}
        />
      )}
      {closeType === "inadmissible" && (
        <ClosedInadmissible
          id={id}
          reportDetail={reportDetail}
          reportExpired={reportExpired}
          closeDate={closeDate}
          reportRender={reportRender}
          editClosed={editClosed}
          setEditClosed={setEditClosed}
        />
      )}
    </div>
  );
};
